import type { ComponentProps } from 'react';
import { Icon } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { EventActionsSocial } from 'features/events/components/event-actions-social';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { useIsLiveStatus } from 'features/events/hooks/useIsLiveStatus';
import type { EventTodo } from '../../../../types';
import { BaseTodoWidgetItem } from '../base-todo-widget-item';

type P = {
  className?: string;
  todo: EventTodo;
  type?: ComponentProps<typeof BaseTodoWidgetItem>['type'];
};

const ProgramEventTodoWidgetItem = ({ className, todo, type }: P) => {
  const { currentUserRsvp, endTime, name, startTime, status, textContent } = todo.event;
  const isLive = useIsLiveStatus({ endTime, startTime, status });

  switch (currentUserRsvp) {
    case 'going':
      return (
        <BaseTodoWidgetItem
          additionalDescription={textContent}
          additionalDescriptionRows={1}
          className={className}
          description={name}
          icon={<Icon icon="calendar-line" />}
          item={<EventActionsSocial event={todo.event} />}
          path={todo.path}
          tags={isLive ? ['live'] : undefined}
          timeConfig={{ options: { display: 'time', mode: 'at' }, time: startTime }}
          title="Join event"
          type={type}
        />
      );
    case 'not_going':
      console.error('Error: The "not_going" case was reached. This is an invalid state and should never occur.');
      return null;
    case 'pending':
      return (
        <BaseTodoWidgetItem
          additionalDescription={textContent}
          additionalDescriptionRows={1}
          className={className}
          description={name}
          icon={<Icon icon="invite" />}
          item={<EventActionsSocial event={todo.event} />}
          path={todo.path}
          tags={isLive ? ['live'] : undefined}
          timeConfig={{ options: { display: 'full' }, time: startTime }}
          title="Respond to invitation"
          type={type}
        />
      );
  }
};

export default ProgramEventTodoWidgetItem;
